import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectSubscription, selectUser } from '../Commonlibs/userSlice';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
  Grid,
  Paper,
  Divider
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import BusinessIcon from '@mui/icons-material/Business';
import HomeIcon from '@mui/icons-material/Home';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FavoriteIcon from '@mui/icons-material/Favorite';
import EditIcon from '@mui/icons-material/Edit';
import SellerpropertyImage from '../assets/SellerpropertyImage.png';
import appar from '../assets/appar.png';
import Loader from '../Loader/Loader';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale);
const centerTextPlugin = {
  id: 'centerText',
  afterDraw: (chart) => {
    const { ctx, width, height, _metasets } = chart;
    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
   
    const chartId = chart.canvas.id;
   
    ctx.font = '12px Outfit, sans-serif';
    ctx.fillStyle = '#6b7280';
    ctx.fillText('Today', width / 2, height / 2 - 10);
   
    ctx.font = 'bold 22px Outfit, sans-serif';
    ctx.fillStyle = '#111827';
   
    if (chartId === 'visitor-chart') {
      ctx.fillText('0', width / 2, height / 2 + 10);
    } else if (chartId === 'engagement-chart') {
      ctx.fillText('125', width / 2, height / 2 + 10);
    }
   
    ctx.restore();
  }
};
ChartJS.register(centerTextPlugin);
const PropertyDashboard = ({ onEditProperty, onSeeAllProperties }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));
  const user = useSelector(selectUser);
  const subscription = useSelector(selectSubscription);
    const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [properties, setProperties] = useState([]);
  const [showProperties, setShowProperties] = useState(true);
  useEffect(() => {
  const fetchUserProfile = async () => {
    try {
      if (user?.id) {
        const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${user.id}`);
        const data = await response.json();
        
        if (data.status === "SUCCESS") {
          setProfileData(data.result);
        }
      }
    } catch (err) {
      console.error('Error fetching profile:', err);
    }
  };
  
  fetchUserProfile();
}, [user]);
  // Fetch property analytics data
  useEffect(() => {
    const fetchPropertyAnalytics = async () => {
      try {
        setLoading(true);
        // Use the user_id from the Redux store if available, otherwise default to 1
        const sellerId = user?.id || 1;
        const response = await axios.get(`https://propertydealstalk.com/api/seller/getSellerPropertyAnalytics?seller_id=${sellerId}`);
        
        if (response.data.status === "SUCCESS") {
          setAnalyticsData(response.data.result);
          
          // Transform API properties to match the component's expected format
          const formattedProperties = response.data.result.properties.map(property => ({
            id: property.property_id,
            title: property.property_details.property_name,
          // Modify this part of the code where the error occurs
price: property.property_details.asking_price 
  ? `${property.property_details.currency}${property.property_details.asking_price.toLocaleString()}`
  : `${property.property_details.currency || ''}0`,
            location: `${property.property_details.area_name}, ${property.property_details.location}`,
            views: property.views,
            favorites: property.favorites,
            image: property.property_details.primary_image ? 
                  `data:image/png;base64,${property.property_details.primary_image}` : 
                  appar,
            status: property.property_details.status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
          }));
          
          setProperties(formattedProperties);
        }
      } catch (error) {
        console.error("Error fetching property analytics:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPropertyAnalytics();
  }, [user]);
  // Check if the user can add a new property based on subscription
  // const handleAddNewProperty = () => {
  //   // if (subscription.plan === 'free' && subscription.propertiesAdded >= subscription.maxProperties) {
  //   //   // If user is on free plan and has reached max properties, navigate to buy plans
  //   //   navigate('/buy-plans');
  //   // } else {
  //   //   // Otherwise, navigate directly to add new property
    
  //   // }
  //     navigate('/add-new-property');
  // };

  // In PropertyDashboard.jsx, modify the handleAddNewProperty function:

const handleAddNewProperty = () => {
  // ✅ Clear all property form data before navigating
  clearAllPropertyFormData();
  navigate('/add-new-property');
};

// ✅ Add this helper function (same as in Navbar)
const clearAllPropertyFormData = () => {
  // Clear AddNewProperty data
  localStorage.removeItem('propertyType');
  localStorage.removeItem('category');
  localStorage.removeItem('propertyLocation');
  
  // Clear PropertyDetails data
  localStorage.removeItem('propertyDetailsFormState');
  
  // Clear PriceDetails data
  localStorage.removeItem('price_askingPrice');
  localStorage.removeItem('price_currency');
  localStorage.removeItem('price_constructionStatus');
  localStorage.removeItem('price_negotiable');
  
  // Clear RentDetails data
  localStorage.removeItem('rent_monthlyRent');
  localStorage.removeItem('rent_currency');
  localStorage.removeItem('rent_availableFrom');
  localStorage.removeItem('rent_securityDeposit');
};

  const outfitFontStyle = {
    fontFamily: 'Outfit, sans-serif'
  };
  // Stats data based on API response
  const statsData = [
    {
      icon: <BusinessIcon sx={{ color: '#3b82f6' }} />,
      count: analyticsData?.total_properties || 0,
      label: 'Total Listed',
      subtext: '+2 this month',
    },
    {
      icon: <HomeIcon sx={{ color: '#3b82f6' }} />,
      count: analyticsData?.active_properties || 0,
      label: 'Active Properties',
      subtext: `${analyticsData ? Math.round((analyticsData.active_properties / analyticsData.total_properties) * 100) : 0}% active rate`,
    },
    {
      icon: <VisibilityIcon sx={{ color: '#3b82f6' }} />,
      count: analyticsData?.total_views || 0,
      label: 'Total Views',
      subtext: '+12% from last month',
    },
    {
      icon: <FavoriteIcon sx={{ color: '#3b82f6' }} />,
      count: analyticsData?.total_favorites || 0,
      label: 'Total Wishlists',
      subtext: '+12% from last month',
    },
  ];
  const visitorAnalyticsChartData = {
    labels: ['Views', 'Inquiries', 'Shares', 'Wishlist'],
    datasets: [
      {
        data: [40, 25, 20, 15],
        backgroundColor: ['#0f52ba', '#4ade80', '#ef4444', '#8b5cf6'],
        borderColor: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'],
        borderWidth: 3,
        circumference: 360,
        hoverOffset: 5,
        borderRadius: 6,
        weight: 1,
      }
    ]
  };
  const engagementAnalyticsChartData = {
    labels: ['Web', 'Mobile', 'Android', 'iOS'],
    datasets: [
      {
        data: [40, 25, 20, 15],
        backgroundColor: ['#0f52ba', '#4ade80', '#ef4444', '#8b5cf6'],
        borderColor: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'],
        borderWidth: 3,
        circumference: 360,
        hoverOffset: 5,
        borderRadius: 6,
        weight: 1,
      }
    ]
  };
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    cutout: '65%',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context) => {
            const label = context.label || '';
            const value = context.raw || 0;
            return `${label}:${value}%`;
          }
        }
      }
    },
    rotation: -90,
    animation: {
      animateScale: true,
      animateRotate: true
    }
  };
  return (
    <Box sx={{ padding: { xs: '16px', md: '16px' } }}>
      {loading && <Loader />}
      
      <Card
        sx={{
          width: '100%',
          background: 'linear-gradient(273.89deg, #60A5FA 0%, #153885 100%)',
          color: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          overflow: 'hidden',
          position: 'relative',
          marginTop: { xs: '30px', md: '-10px' },
        }}
      >
        <CardContent sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: { xs: 3, sm: 0 },
          padding: { xs: '20px', sm: '24px' },
          '&:last-child': { paddingBottom: { xs: '20px', sm: '24px' } }
        }}>
          <Box>
        <Typography
  variant="h5"
  sx={{
    fontFamily: 'Outfit, sans-serif',
    fontWeight: 400,
    fontSize: { xs: '22px', sm: '18px' },
    marginBottom: '8px'
  }}
>
  Welcome back,
  {/* <span style={{ fontWeight: 500, fontSize:'24px'}}>
    {profileData?.full_name || user?.name || 'User'}!
  </span> */}
</Typography>
            <Typography
              variant="body2"
              sx={{
                ...outfitFontStyle,
                fontSize: '14px',
                opacity: 0.9
              }}
            >
              Here's what's happening with your properties today.
            </Typography>
          </Box>
         
          <Box sx={{
            display: 'flex',
            gap: 2,
            flexDirection: { xs: 'column', md: 'row' },
            width: { xs: '100%', sm: 'auto' }
          }}>
             <Button
              variant="contained"
              startIcon={<AddIcon />}
              fullWidth={isMobile}
              onClick={handleAddNewProperty}
              sx={{
                ...outfitFontStyle,
                backgroundColor: 'white',
                color: '#1e3a8a',
                textTransform: 'none',
                fontWeight: 500,
                '&:hover': {
                  backgroundColor: '#f8f9fa',
                },
                padding: '8px 16px',
                borderRadius: '8px',
                boxShadow: 'none',
                whiteSpace: 'nowrap'
              }}
            >
              Post Property
            </Button>
           <Button
  variant="contained"
  startIcon={<MailOutlineIcon />}
  fullWidth={isMobile}
  onClick={() => navigate('/profile/inbox')}
  sx={{
    ...outfitFontStyle,
    backgroundColor: '#ffc107',
    color: '#ffff',
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#ffca28',
    },
    padding: '8px 16px',
    borderRadius: '8px',
    boxShadow: 'none'
  }}
>
  Messages
</Button>
          </Box>
        </CardContent>
      </Card>
     
      <Paper
        elevation={0}
        sx={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: { xs: '16px', md: '75px' },
          marginTop: '24px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '16px',
            overflowX: { xs: 'auto', md: 'visible' },
            pb: { xs: 2, md: 0 },
          }}
        >
          {statsData.map((stat, index) => (
            <Card
              key={index}
              elevation={0}
              sx={{
                borderRadius: '8px',
                border: '1px solid #f0f0f0',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                },
                flex: '1 0 0',
                minWidth: { xs: '200px', md: '0' },
              }}
            >
              <CardContent sx={{ padding: '16px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Box
                    sx={{
                      backgroundColor: '#ebf5ff',
                      borderRadius: '8px',
                      width: '40px',
                      height: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#6b7280',
                      '&:hover': { color: '#3b82f6' },
                      cursor: 'pointer'
                    }}
                  >
                    <Box component="span" sx={{ mr: 1 }}>
                      {'>'}
                    </Box>
                  </Box>
                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    ...outfitFontStyle,
                    fontWeight: 600,
                    fontSize: '18px',
                    mb: 1
                  }}
                >
                  {stat.count}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    ...outfitFontStyle,
                    color: '#4b5563',
                    fontSize: '14px',
                    fontWeight: 500,
                    mb: 0.5,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {stat.label}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    ...outfitFontStyle,
                    color: 'rgba(25, 62, 140, 1)',
                    fontSize: '12px',
                    fontWeight: 500
                  }}
                >
                  {stat.subtext}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
       
        <Box sx={{ my: 6 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 3
            }}
          >
            <Typography
              variant="h6"
              sx={{
                ...outfitFontStyle,
                fontWeight: 600,
                fontSize: '18px',
                color: '#111827'
              }}
            >
              Your Properties
            </Typography>
            <Typography
              component="span"
              onClick={onSeeAllProperties}
              sx={{
                ...outfitFontStyle,
                fontSize: '14px',
                color: '#3b82f6',
                cursor: 'pointer',
                fontWeight: 500,
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              See all
            </Typography>
          </Box>
         
          {showProperties && properties.length > 0 ? (
            // FIXED: Changed to Box with scrollable container for mobile
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                overflowX: 'auto',
                gap: 2,
                pb: 2,
                // Add smooth scrolling
                scrollBehavior: 'smooth',
                '&::-webkit-scrollbar': {
                  height: '6px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'rgba(0,0,0,0.2)',
                  borderRadius: '6px',
                },
              }}
            >
              {properties.slice(0, 3).map((property) => (
                <Box
                  key={property.id}
                  sx={{
                    flex: {
                      xs: '0 0 calc(100% - 16px)', // Full width on extra small screens with some margin
                      sm: '0 0 calc(50% - 16px)', // Half width on small screens
                      md: '0 0 calc(33.333% - 16px)', // One third on medium and up
                    },
                    maxWidth: {
                      xs: 'calc(100% - 16px)',
                      sm: 'calc(50% - 16px)',
                      md: 'calc(33.333% - 16px)',
                    },
                    height: '280px',
                  }}
                >
                  <Card
                    sx={{
                      borderRadius: '12px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                      height: '100%',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      position: 'relative'
                    }}
                  >
                    {property.status && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 10,
                          right: 10,
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          color: 'white',
                          padding: '4px 10px',
                          borderRadius: '4px',
                          fontSize: '10px',
                          fontWeight: 500,
                          zIndex: 1
                        }}
                      >
                        {property.status}
                      </Box>
                    )}
                   
                    <Box
                      sx={{
                        position: 'relative',
                        width: '100%',
                        height: '140px',
                        overflow: 'hidden'
                      }}
                    >
                      <Box
                        component="img"
                        src={property.image}
                        alt={property.title}
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          objectPosition: 'center'
                        }}
                      />
                    </Box>
                   
                    <CardContent
                      sx={{
                        p: 1.5,
                        flexGrow: 1,
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Box>
                        <Box sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mb: 1,
                          gap: 2
                        }}>
                          <Typography
                            variant="h6"
                            sx={{
                              ...outfitFontStyle,
                              fontWeight: 600,
                              fontSize: '14px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: '70%'
                            }}
                          >
                            {property.title}
                          </Typography>
                          <Button
                            size="small"
                            onClick={() => onEditProperty(property)}
                            sx={{
                              minWidth: 'auto',
                              p: 0,
                              color: '#666',
                              fontSize: '10px',
                              textTransform: 'none'
                            }}
                          >
                            Edit
                          </Button>
                        </Box>
                       
                                                <Typography
                          variant="body1"
                          sx={{
                            ...outfitFontStyle,
                            fontWeight: 600,
                            color: '#3b82f6',
                            mb: 0.5,
                            fontSize: '13px'
                          }}
                        >
                          {property.price}
                        </Typography>
                       
                        <Typography
                          variant="body2"
                          sx={{
                            ...outfitFontStyle,
                            color: '#666',
                            mb: 0.5,
                            fontSize: '12px'
                          }}
                        >
                          {property.location}
                        </Typography>
                      </Box>
                     
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mt: 0.5
                      }}>
                        <VisibilityIcon sx={{ fontSize: 14, color: '#999', mr: 0.5 }} />
                        <Typography
                          variant="caption"
                          sx={{
                            ...outfitFontStyle,
                            color: '#666',
                            fontSize: '11px'
                          }}
                        >
                          {property.views} Views
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              ))}
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: { xs: 3, md: 4 }
              }}
            >
              <Box
                component="img"
                src={SellerpropertyImage}
                alt="Buildings illustration"
                sx={{
                  width: { xs: '150px', sm: '180px', md: '200px' },
                  height: 'auto',
                  mb: 3
                }}
              />
             
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: 'center',
                  gap: { xs: 2, sm: 3 }
                }}
              >
                <Typography
                  sx={{
                    ...outfitFontStyle,
                    color: '#4b5563',
                    fontSize: '16px',
                    fontWeight: 500
                  }}
                >
                  No Property Added
                </Typography>
               
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={handleAddNewProperty}
                  sx={{
                    ...outfitFontStyle,
                    color: '#3b82f6',
                    borderColor: '#3b82f6',
                    textTransform: 'none',
                    fontWeight: 500,
                    '&:hover': {
                      backgroundColor: 'rgba(59, 130, 246, 0.04)',
                      borderColor: '#3b82f6',
                    },
                    padding: '8px 16px',
                    borderRadius: '8px'
                  }}
                >
                  Add New Property
                </Button>
              </Box>
            </Box>
          )}
        </Box>
       
        <Box>
          <Grid container spacing={{ xs: 4, md: 18 }} justifyContent="center">
            <Grid item xs={12} sm={6} md={5} lg={4}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    ...outfitFontStyle,
                    fontWeight: 600,
                    fontSize: '18px',
                    color: '#111827',
                    mb: 2
                  }}
                >
                  Visitor Analytics
                </Typography>
               
                <Box
                  sx={{
                    position: 'relative',
                    width: '160px',
                    height: '160px',
                    margin: '0 auto',
                    mb: 3,
                    backgroundColor: '#ffffff',
                    borderRadius: '50%',
                  }}
                >
                  <Doughnut
                    data={visitorAnalyticsChartData}
                    options={chartOptions}
                    id="visitor-chart"
                  />
                 
                  {/* FIXED: Adjusted positioning for mobile */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '25%',
                      left: { xs: '100%', sm: '160px' },
                      display: 'flex',
                      alignItems: 'center',
                      maxWidth: { xs: 'calc(100vw - 200px)', sm: 'auto' },
                      transform: { xs: 'translateX(-50%)', sm: 'none' },
                    }}
                  >
                    <Box
                      sx={{
                        width: '30px',
                        height: '1px',
                        backgroundColor: '#000',
                        position: 'relative',
                        marginRight: '10px'
                      }}
                    />
                   
                    <Box
                      sx={{
                        backgroundColor: 'white',
                        padding: '8px 20px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        fontFamily: 'Outfit, sans-serif',
                        fontWeight: 500,
                        fontSize: '16px',
                        color: '#111827',
                        minWidth: '40px',
                        textAlign: 'center'
                      }}
                    >
                      {analyticsData?.total_views || 0}
                    </Box>
                  </Box>
                </Box>
               
                <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#0f52ba'
                      }}
                    />
                    <Typography sx={{ fontSize: '12px', color: '#4b5563', fontFamily: 'Outfit, sans-serif' }}>
                      Views
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#4ade80'
                      }}
                    />
                    <Typography sx={{ fontSize: '12px', color: '#4b5563', fontFamily: 'Outfit, sans-serif' }}>
                      Inquiries
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#ef4444'
                      }}
                    />
                    <Typography sx={{ fontSize: '12px', color: '#4b5563', fontFamily: 'Outfit, sans-serif' }}>
                      Shares
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#8b5cf6'
                      }}
                    />
                    <Typography sx={{ fontSize: '12px', color: '#4b5563', fontFamily: 'Outfit, sans-serif' }}>
                      Wishlist
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
           
            <Grid item xs={12} sm={6} md={5} lg={4}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    ...outfitFontStyle,
                    fontWeight: 600,
                    fontSize: '18px',
                    color: '#111827',
                    mb: 2
                  }}
                >
                  Engagement Analytics
                </Typography>
               
                <Box
                  sx={{
                    position: 'relative',
                    width: '160px',
                    height: '160px',
                    margin: '0 auto',
                                        mb: 3,
                    backgroundColor: '#ffffff',
                    borderRadius: '50%',
                  }}
                >
                  <Doughnut
                    data={engagementAnalyticsChartData}
                    options={chartOptions}
                    id="engagement-chart"
                  />
                 
                  {/* FIXED: Adjusted positioning for mobile */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '25%',  
                      left: { xs: '100%', sm: '160px' },
                      display: 'flex',
                      alignItems: 'center',
                      maxWidth: { xs: 'calc(100vw - 200px)', sm: 'auto' },
                      transform: { xs: 'translateX(-50%)', sm: 'none' },
                    }}
                  >
                    <Box
                      sx={{
                        width: '30px',
                        height: '1px',
                        backgroundColor: '#000',
                        position: 'relative',
                        marginRight: '10px'
                      }}
                    />
                   
                    <Box
                      sx={{
                        backgroundColor: 'white',
                        padding: '8px 20px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        fontFamily: 'Outfit, sans-serif',
                        fontWeight: 500,
                        fontSize: '16px',
                        color: '#111827',
                        minWidth: '40px',
                        textAlign: 'center'
                      }}
                    >
                      125
                    </Box>
                  </Box>
                </Box>
               
                <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#0f52ba'
                      }}
                    />
                    <Typography sx={{ fontSize: '12px', color: '#4b5563', fontFamily: 'Outfit, sans-serif' }}>
                      Web
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#4ade80'
                      }}
                    />
                    <Typography sx={{ fontSize: '12px', color: '#4b5563', fontFamily: 'Outfit, sans-serif' }}>
                      Mobile
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#ef4444'
                      }}
                    />
                    <Typography sx={{ fontSize: '12px', color: '#4b5563', fontFamily: 'Outfit, sans-serif' }}>
                      Android
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#8b5cf6'
                      }}
                    />
                    <Typography sx={{ fontSize: '12px', color: '#4b5563', fontFamily: 'Outfit, sans-serif' }}>
                      iOS
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* Display insights from API data */}
        {analyticsData?.insights && analyticsData.insights.length > 0 && (
          <Box sx={{ mt: 6 }}>
            <Typography
              variant="h6"
              sx={{
                ...outfitFontStyle,
                fontWeight: 600,
                fontSize: '18px',
                color: '#111827',
                mb: 3
              }}
            >
              Property Insights
            </Typography>
            
            <Grid container spacing={2}>
              {analyticsData.insights.map((insight, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: '8px',
                      border: '1px solid #f0f0f0',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                      },
                      height: '100%'
                    }}
                  >
                    <CardContent>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Box
                          sx={{
                            backgroundColor: insight.type === 'top_performer' ? '#ebf5ff' : '#fff5f5',
                            borderRadius: '8px',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mr: 2
                          }}
                        >
                          {insight.type === 'top_performer' ? (
                            <FavoriteIcon sx={{ color: '#3b82f6' }} />
                          ) : (
                            <VisibilityIcon sx={{ color: '#ef4444' }} />
                          )}
                        </Box>
                        <Typography
                          variant="h6"
                          sx={{
                            ...outfitFontStyle,
                            fontWeight: 600,
                            fontSize: '16px'
                          }}
                        >
                          {insight.type === 'top_performer' ? 'Top Performer' : 'Needs Attention'}
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{
                          ...outfitFontStyle,
                          color: '#4b5563',
                          fontSize: '14px',
                          ml: 7
                        }}
                      >
                        {insight.message}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      </Paper>
    </Box>
  );
};
export default PropertyDashboard;